import { createSlice, configureStore, createStore, applyMiddleware, compose } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import rootReducer from './rootReducer'

import { thunk } from 'redux-thunk'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'root',
  storage,
//   whitelist: ['auth', 'user'] // only these slices will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = createStore(rootReducer, 
//     composeEnhancers(applyMiddleware(thunk)))
// export default store

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);